import { render, staticRenderFns } from "./NavBarUserRegister.vue?vue&type=template&id=dd4a78c2&scoped=true&"
import script from "./NavBarUserRegister.vue?vue&type=script&lang=js&"
export * from "./NavBarUserRegister.vue?vue&type=script&lang=js&"
import style0 from "./NavBarUserRegister.vue?vue&type=style&index=0&id=dd4a78c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd4a78c2",
  null
  
)

export default component.exports